var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":{ name: 'AssetHome', params: { id: _vm.assetNum }}}},[_c('button',{staticClass:"glossy-button glossy-button--green"},[_c('i',{staticClass:"fa fa-plus"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }